<script lang="ts" setup></script>
<template>
  <svg
    width="18"
    height="17"
    viewBox="0 0 18 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 11H5H7.5H9.5H14.5V7V4V2.5L13.5 1.5H12H10H4.5L4 3V4V11Z"
      fill="var(--primary)"
      stroke="var(--primary)"
      stroke-width="0.2"
    />
    <path
      d="M14.4483 12.9396V10.8965H5.59486C4.46649 10.8965 3.55176 11.8113 3.55176 12.9396M6.82072 14.9827H12.269C13.0318 14.9827 13.4132 14.9827 13.7046 14.8343C13.9609 14.7037 14.1693 14.4953 14.2998 14.239C14.4483 13.9477 14.4483 13.5663 14.4483 12.8034V3.54137C14.4483 2.77854 14.4483 2.39712 14.2998 2.10576C14.1693 1.84947 13.9609 1.6411 13.7046 1.51052C13.4132 1.36206 13.0318 1.36206 12.269 1.36206H6.82072C5.67648 1.36206 5.10435 1.36206 4.66731 1.58475C4.28288 1.78062 3.97032 2.09318 3.77444 2.47761C3.55176 2.91466 3.55176 3.48678 3.55176 4.63102V11.7138C3.55176 12.858 3.55176 13.4301 3.77444 13.8672C3.97032 14.2516 4.28288 14.5642 4.66731 14.76C5.10435 14.9827 5.67648 14.9827 6.82072 14.9827Z"
      stroke="var(--primary)"
      stroke-width="1.36207"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
